<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="delClass" header="Received">
        <Modal
          size="lg"
          title="Choose location"
          class="modal-primary backlogCities"
          v-model="modalView"
          @on-ok="modalView = false"
          :transfer="false"
        >
          <b-form-input
            style="display:inline-block; width:250px;"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <LoadingCard v-if="!dataReady"></LoadingCard>
          <b-row v-else style="padding:2em;">
            <b-col
              lg="4"
              sm="6"
              v-for="location in filterItems(locations)"
              :key="location.id"
              style="padding: 5px;"
            >
              <a
                class="locationLabels"
                style="font-size:1.2em;"
                :href="
                  '#/base/CityDashboard/?loc=' +
                    location.id +
                    '&city=' +
                    location.location +
                    '&lat=' +
                    location.lat +
                    '&lng=' +
                    location.lng
                "
                v-b-tooltip.hover
                :title="location.id + ' - ' + location.contact"
                >{{ location.location }} ({{ location.backlog }})</a
              >
            </b-col>
          </b-row>
        </Modal>
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Active Backlog"
            backProductGroups="true"
            productGroupsEmit="showDetails"
            @showDetails="detailView"
          ></HeaderTitle>
          <HeaderControl
            :showDownloadPdfIcon="true"
            @emit-pdf-download="
              changeChart ? downloadPDFChangeChart() : downloadPDF()
            "
            :loadingPdf="loadingPdf"
          ></HeaderControl>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="details == 1"
            @click="replaceCharts"
            class="btn-outline btn-sm ml-1"
            variant="outline-primary"
            right
          >
            Product Groups Total
          </b-button>
          <b-button
            @click="modalView = true"
            v-if="(details = 1)"
            class="btn-outline btn-sm ml-1"
            variant="outline-primary"
            right
          >
            By Location
          </b-button>
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else-if="!loadingData && changeChart == false"
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
          <highcharts
            v-else-if="!loadingData && changeChart == true"
            ref="backRefChangeChart"
            :options="chartOptionsChangeChart"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <ShowHideCheckobox
            :show="changeChart == false"
            @toggleData="toggleData($event, $refs.backRef)"
          ></ShowHideCheckobox>
        </div>
        <FooterOptions
          :showTop10="true"
          :showAll="true"
          :showOverall="false"
          @top-10-all-data-emit="top10AllDataEmit"
        ></FooterOptions>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import { Switch as cSwitch } from "@coreui/vue";
import HeaderTitle from "../../shared/HeaderTitle.vue";
import HeaderControl from "../../shared/HeaderControl.vue";
import FooterOptions from "../../shared/FooterOptions.vue";
import LoadingCard from "../../shared/LoadingCard.vue";
import ShowHideCheckobox from "../../shared/ShowHideCheckobox.vue";
import { from, isUserLoggedIn, to, toggleData } from "../../../utils/Utils";
import {
  ActiveBacklogStackedChart,
  ProductModelColumnThreeChart
} from "../../../utils/ChartProps";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
exporting(Highcharts);

export default {
  name: "ActiveBacklogStacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch,
    HeaderTitle,
    HeaderControl,
    FooterOptions,
    LoadingCard,
    ShowHideCheckobox
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity", "details"],
  data: function() {
    return {
      toggleData: toggleData,
      from: from,
      to: to,
      fullscreen: false,
      dataReady: false,
      changeChart: false,
      locations: [],
      searchQuery: "",
      loadingData: false,
      loadingPdf: false,
      showAll: false,
      modalDate: false,
      totalValue: null,
      modalView: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {},
      chartOptionsChangeChart: {}
    };
  },

  watch: {
    totalValue() {
      var pointSum = 0;
      if (
        this.$refs.backRef &&
        this.$refs.backRef.chart &&
        this.$refs.backRef.chart.series
      ) {
        var chartSeries = this.$refs.backRef.chart.series;
        chartSeries.forEach(function(obj) {
          if (obj.visible == true) {
            obj.yData.forEach(function(datas) {
              pointSum += datas;
            });
          }
        });
      }
      this.totalValue = pointSum;
      this.chartOptions.title.text = "Total units: " + this.totalValue;
    },
    fullscreen(value) {
      if (value == false) {
        this.detailView();
      }
    }
  },

  methods: {
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    detailView() {
      this.$emit("detailView");
    },
    replaceCharts() {
      this.changeChart = !this.changeChart;
      this.changeChart ? this.fetchDataChangeChart() : this.fetchData();
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".delClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.$refs.backRef) {
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      }
    },
    fetchData() {
      if (!this.changeChart) {
        this.loadingData = true;

        let params = {};
        params = {
          chartType: "backlog"
        };
        this.$http
          .get("api/charts/chart_data.php", {
            params
          })
          .then(
            res => {
              let getReady = res.data.stackedData;
              let myArray = getReady;
              let xAxis = [];
              var datum = [];

              var fiber = {
                name: "Fiber Gear",
                data: [],
                color: "rgb(124, 181, 236)"
              };
              var power = {
                name: "Power Supply",
                data: [],
                color: "rgb(247, 163, 92)"
              };
              var line = {
                name: "Line Gear",
                data: [],
                color: "rgb(144, 237, 125)"
              };
              var meter = {
                name: "Meter",
                data: [],
                color: "rgb(145, 232, 225)"
              };
              var transponder = {
                name: "Transponder",
                data: [],
                color: "rgb(241, 92, 128)"
              };
              var headend = {
                name: "Headend",
                data: [],
                color: "rgb(43, 144, 143)"
              };
              var wireless = {
                name: "Wireless",
                data: [],
                color: "rgb(23, 114, 143)"
              };

              for (var type in myArray) {
                datum.push([type, myArray[type]]);
              }
              datum.sort((a, b) =>
                parseFloat(a[1].Total) > parseFloat(b[1].Total) ? -1 : 1
              );
              if (!this.showAll) {
                datum = datum.slice(0, 10);
              }
              datum.forEach(obj => {
                xAxis.push(obj[0]);
                Object.entries(obj[1]).forEach(([key, value]) => {
                  var tempValue = parseInt(value);

                  switch (key) {
                    case "Fiber Gear":
                      fiber.data.push(tempValue);

                      break;
                    case "Power Supply":
                      power.data.push(tempValue);

                      break;
                    case "Line Gear":
                      line.data.push(tempValue);

                      break;
                    case "Meter":
                      meter.data.push(tempValue);

                      break;
                    case "Transponder":
                      transponder.data.push(tempValue);
                      break;
                    case "Headend":
                      headend.data.push(tempValue);
                      break;
                    case "Wireless":
                      wireless.data.push(tempValue);
                      break;
                  }
                });
              });
              if (!this.showAll) {
                this.chartOptions.xAxis.categories = xAxis.slice(0, 10);
              } else {
                this.chartOptions.xAxis.categories = xAxis;
              }
              this.chartOptions.series[0] = fiber;
              this.chartOptions.series[1] = power;
              this.chartOptions.series[2] = line;
              this.chartOptions.series[3] = meter;
              this.chartOptions.series[4] = transponder;
              this.chartOptions.series[5] = headend;
              this.chartOptions.series[6] = wireless;

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };

              this.chartOptions.legend.labelFormatter = function() {
                var dataGet = this.yData;
                var summaryData = 0;
                dataGet.forEach(function(point) {
                  summaryData += point;
                });
                return (
                  "<b>" +
                  this.name +
                  "</b> <small><br>Total: " +
                  summaryData +
                  "</small>"
                );
              };
              this.totalValue = res.data.totals;
              this.chartOptions.title.text = "Total units: " + res.data.totals;

              if (this.details == 1) {
                this.chartOptions.chart.height = "45%";
              }
              this.loadingData = false;
            },
            err => {
              this.loadingData = false;
              console.log(err);
            }
          );
      }
    },

    fetchDataChangeChart() {
      if (this.changeChart) {
        this.loadingData = true;
        let params = {};

        params = {};
        this.$http.get("api/charts/prodModelBacklog.php", { params }).then(
          res => {
            this.chartOptionsChangeChart.title.text =
              "Total units: " + res.data.totals;

            let tmp = res.data.upData;
            tmp.sort((a, b) => (parseFloat(a.y) > parseFloat(b.y) ? -1 : 1));

            let smp = res.data.dnData;
            smp.forEach(obj => {
              obj.data.sort((a, b) =>
                parseFloat(a.y) > parseFloat(b.y) ? -1 : 1
              );
              obj.data.splice(20, 5000);
            });

            let newArr = tmp.slice(0, 10);
            if (this.locParam == 0) {
              if (smp.length != 0) {
                this.chartOptionsChangeChart.series[0].data = smp[0].data;
              }
            } else {
              this.chartOptionsChangeChart.series[0].data = newArr;
              this.chartOptionsChangeChart.drilldown.series = smp;
            }

            this.chartOptionsChangeChart.chart.height = "45%";
            this.loadingData = false;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
      }
    },

    fetchLocation() {
      this.$http.get("api/charts/locationsBacklogCount.php").then(
        res => {
          const parsedData = res.data;
          this.locations = parsedData;
          this.dataReady = true;
        },
        err => {
          console.log(err);
        }
      );
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.location.match(regex);
      });
    },

    downloadPDF() {
      this.loadingPdf = true;
      if (this.$refs.backRef && this.$refs.backRef.chart) {
        if (this.locParam == 1) {
          this.$refs.backRef.chart.options.title.text =
            "Active Backlog | " + this.dateTo;
        } else {
          this.$refs.backRef.chart.options.title.text =
            "Active Backlog | " + this.dateTo + " " + this.nameCity;
        }

        this.$refs.backRef.chart.options.title.style.display = "block";
        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
          "black";
        this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

        this.$refs.backRef.chart.options.xAxis.forEach(obj => {
          obj.labels.style.color = "black";
        });
        this.$refs.backRef.chart.options.yAxis.forEach(obj => {
          obj.labels.style.color = "black";
        });

        this.$refs.backRef.chart.exportChart({
          type: "application/pdf",
          filename: "ActiveBacklog-" + this.dateTo
        });

        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
          "white";
        this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
      }
      this.loadingPdf = false;
    },
    downloadPDFChangeChart() {
      if (this.locParam == 1) {
        this.$refs.backRefChangeChart.chart.options.title.text =
          "Regional Analytics Active Backlog | " +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          this.locationName;
        this.$refs.backRefChangeChart.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRefChangeChart.chart.options.title.text =
          "Regional Analytics Active Backlog | " + this.from
            ? this.from
            : this.dateFrom + this.nameCity;
        this.$refs.backRefChangeChart.chart.options.title.style.color = "black";
      }

      this.$refs.backRefChangeChart.chart.options.title.style.display = "block";
      this.$refs.backRefChangeChart.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRefChangeChart.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRefChangeChart.chart.exportChart({
        type: "application/pdf",
        filename:
          "RegionalBacklog-" +
          (this.from(this.dateFrom) ? this.from(this.dateFrom) : this.dateFrom)
      });

      this.$refs.backRefChangeChart.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    },
    changeTotalValue() {
      this.totalValue = null;
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = ActiveBacklogStackedChart(
      router,
      this.changeTotalValue
    );
    this.chartOptionsChangeChart = ProductModelColumnThreeChart(
      router,
      this.locationsIds
    );
    this.fetchData();
    if (this.details == 1) {
      this.toggleFullScreen();
      this.fetchLocation();
    }
  }
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>

<style>
.highcharts-exporting-group {
  display: none !important;
}
.backlogCities .ivu-modal {
  width: 780px !important;
}
</style>
